import { SourceComponents } from '@updater/informant-core';
import { Box } from '@updater/ui-uds';

export const ScreenContents: SourceComponents['ScreenContents'] = (props) => {
  return <Box mb="m" {...props} />;
};
